// extracted by mini-css-extract-plugin
module.exports = {"root":"modal-footer_root__TzaNb","container":"modal-footer_container__VtuvV"};